import { Injectable } from '@angular/core';
import * as _ from 'underscore';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  livoNumber = false;
  as400Number = false;
  both = false;
  allLivoPolicy: any = [];

  getAs400ActivePolicy(policies) {
    return _.filter(policies, (policy) => {
      return (
        policy.policynumber.policyNumber.length === 6 &&
        policy.policyStatus === 'ACTIVE'
      );
    });
  }
  getAllAs400Policy(policies) {
    return _.filter(policies, (policy) => {
      return policy.policynumber.policyNumber.length === 6;
    });
  }
  getLivoActivePolicy(policies) {
    return _.filter(policies, (policy) => {
      return (
        policy.policynumber.policyNumber.length > 6 &&
        policy.policyStatus === 'ACTIVE'
      );
    });
  }
  getAllLivoPolicy(policies) {
    return _.filter(policies, (policy) => {
      return policy.policynumber.policyNumber.length > 6;
    });
  }
  setTypeOfNumber(allAs400Policy, livoActivePolicy, as400ActivePolicy) {
    if (allAs400Policy.length > 0 && this.allLivoPolicy.length > 0) {
      if (as400ActivePolicy.length > 0 && livoActivePolicy.length === 0) {
        this.as400Number = true;
      } else if (
        as400ActivePolicy.length === 0 &&
        livoActivePolicy.length > 0
      ) {
        this.livoNumber = true;
      } else if (
        as400ActivePolicy.length > 0 &&
        livoActivePolicy.length > 0
      ) {
        this.both = true;
      } else {
        this.as400Number = true;
      }
    }
  }
  dynamicContact(policies, policyType) {
    if (policyType.length > 1) {
      let as400ActivePolicy: any = [];
      let livoActivePolicy: any = [];
      let allAs400Policy: any = [];

      as400ActivePolicy = this.getAs400ActivePolicy(policies);

      allAs400Policy = this.getAllAs400Policy(policies);

      livoActivePolicy = _.filter(policies, (policy) => {
        return (
          policy.policynumber.policyNumber.length == 10 &&
          policy.policyStatus == 'ACTIVE'
        );
      });

      this.allLivoPolicy = _.filter(policies, (policy) => {
        return policy.policynumber.policyNumber.length == 10;
      });

      if (allAs400Policy.length > 0 || this.allLivoPolicy.length > 0) {
        if (as400ActivePolicy.length > 0 && livoActivePolicy.length == 0) {
          this.as400Number = true;
        } else if (
          as400ActivePolicy.length == 0 &&
          livoActivePolicy.length > 0
        ) {
          this.livoNumber = true;
        } else if (
          as400ActivePolicy.length > 0 &&
          livoActivePolicy.length > 0
        ) {
          this.both = true;
        } else {
          this.as400Number = true;
        }
      }
    } else if (policyType.length == 1 && policyType[0] == '10') {
      this.livoNumber = true;
    } else if (policyType.length === 1 && policyType[0] === '6') {
      this.as400Number = true;
    }
  }
}
